import { createFileRoute } from '@tanstack/react-router'

// Bare /employees (no employee selected): EmployeesLayout renders the full-width rail with its
// SlideInPanel closed, so this index match renders nothing into the (collapsed) detail Outlet.
// Selecting an employee navigates to `/employees/$employeeId/report`.
export const Route = createFileRoute('/_app/employees/_list/')({})
